module.exports = __webpack_public_path__ + "assets/img/z12.6bd46a40.png";